import {
  AnnotationListColumn,
  AnnotationListColumns,
} from '@rossum/api-client/shared';
import { getColumnName } from '../document-list-columns/utils';
import { PanelColumn } from './types';

export const SEARCH_VALUE_MIN_LENGTH = 3;

export const searchValueIsTooShort = (searchValue: string) =>
  searchValue.length < SEARCH_VALUE_MIN_LENGTH;

export const getAnnotationListColumns = (
  tableColumns: Array<PanelColumn>
): AnnotationListColumns =>
  tableColumns.map(col =>
    col.columnType === 'meta'
      ? {
          columnType: col.columnType,
          metaName: col.metaName,
          width: col.width,
          visible: col.visible,
        }
      : {
          columnType: col.columnType,
          schemaId: col.schemaId,
          dataType: col.dataType,
          width: col.width,
          visible: col.visible,
          scoreThreshold: col.scoreThreshold,
        }
  );

// when the user changes status tab it is likely that the table config saved in the database won't match the table columns displayed in the ui
// This fn is used to not overwrite tables when performing PATCH operations
export const preserveMissingColumns = <T extends AnnotationListColumn>({
  updatedColumns,
  previousColumns,
}: {
  previousColumns: T[];
  updatedColumns: T[];
}) => {
  const missingColumnIndexPairs = previousColumns.flatMap((column, index) =>
    updatedColumns.some(c => getColumnName(c) === getColumnName(column))
      ? []
      : [[column, index] as const]
  );

  // here we add missing/hidden columns preserving their column order (index)
  return missingColumnIndexPairs.reduce((acc, [col, index]) => {
    acc.splice(index, 0, col);
    return acc;
  }, updatedColumns);
};
